export const CheckIcon = () => (
  <svg
    width='20'
    height='20'
    viewBox='0 0 22 22'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    aria-hidden='true'
  >
    <path
      d='M11.0004 21.266C16.6705 21.266 21.267 16.6694 21.267 10.9993C21.267 5.32916 16.6705 0.732617 11.0004 0.732617C5.33023 0.732617 0.733691 5.32916 0.733691 10.9993C0.733691 16.6694 5.33023 21.266 11.0004 21.266Z'
      fill='#4BBF2A'
    />
    <path
      d='M6.6 11.5009L8.67554 13.7306C8.90962 13.982 9.34598 14.0028 9.61086 13.7751L15.4 8.8'
      stroke='white'
      strokeWidth='2.2'
      strokeLinecap='round'
    />
  </svg>
)
